import React, { useEffect, useRef } from 'react';
import Button from '../ui/Button/Button';
import './DeleteConfirmation.css';

interface DeleteConfirmationProps {
  prompt: React.ReactNode;
  warning: React.ReactNode;
  confirmLabel: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  deletingLabel?: string;
  showWarningIcon?: boolean;
  confirmTestId?: string;
}

export function DeleteConfirmation({
  prompt,
  warning,
  confirmLabel,
  isDeleting,
  onConfirm,
  onCancel,
  title,
  deletingLabel = 'Deleting...',
  showWarningIcon = false,
  confirmTestId
}: DeleteConfirmationProps) {
  const confirmButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    confirmButtonRef.current?.focus();
  }, []);

  return (
    <div className="delete-confirmation">
      {showWarningIcon && (
        <div className="delete-confirmation__icon" aria-hidden="true">⚠️</div>
      )}
      {title && <h4 className="delete-confirmation__title">{title}</h4>}
      <p className="delete-confirmation__prompt">{prompt}</p>
      <p className="delete-confirmation__warning">{warning}</p>

      <div className="form-actions">
        <Button
          ref={confirmButtonRef}
          size="action"
          type="button"
          onClick={onConfirm}
          variant="danger"
          disabled={isDeleting}
          data-testid={confirmTestId}
        >
          {isDeleting ? deletingLabel : confirmLabel}
        </Button>
        <Button
          size="action"
          type="button"
          onClick={onCancel}
          variant="secondary"
          disabled={isDeleting}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
